import React from 'react';

// Handwritten note from the redesign: Caveat script, one underline swash per line.
// `text` uses "\n" between lines (see the `scribbles` translation keys).
const Scribble = ({ text, className = '' }) => (
  <p className={`r4l-scribble ${className}`.trim()} aria-hidden="true">
    {String(text || '').split('\n').map((line, i) => (
      <React.Fragment key={i}>
        {i > 0 && <br />}
        {line}
        <i />
      </React.Fragment>
    ))}
  </p>
);

export default Scribble;
